import { CommonModule } from '@angular/common';
import { Component, computed, inject, signal } from '@angular/core';
import { Icon } from '../../../shared/components/icon';
import { Divider } from "../../../shared/components/divider";
import { MenuItem } from '../../../shared/models/menu-item';
import { Store } from '@ngrx/store';
import { Router, RouterLink } from '@angular/router';
import { User } from '../../../features/login/models/user';
import { selectUser } from '../../../state/auth/auth.selectors';
import { ProfileHeader } from "../profile-header";

@Component({
  selector: 'app-header',
  templateUrl: './header.html',
  styleUrls: ['./header.scss'],
  imports: [CommonModule, Icon, Divider, ProfileHeader, RouterLink]
})
export class Header {
  openDropdown: string | null = null;
  activeSection = signal<MenuItem | null>(null);
  private store = inject(Store);
  router = inject(Router);
  user = this.store.selectSignal<User | null>(selectUser);

  userLogged = computed(() => {
      const initial = `${this.user()?.nome.charAt(0).toUpperCase()}${this.user()?.cognome.charAt(0).toUpperCase()}`;
      const fullName = `${this.user()?.nome} ${this.user()?.cognome}`;
      return {
        initial: initial,
        fullName: fullName
      };
  })

  toggleDropdown(dropdownName: string): void {
    this.openDropdown = this.openDropdown === dropdownName ? null : dropdownName;
  }

  isOpen(dropdownName: string): boolean {
    return this.openDropdown === dropdownName;
  }
}
